import React, {useEffect} from 'react';
import './FernrauschApp.scss';
import PopupMenuView from '../popupmenu/PopupMenuView';
import {useModel} from '../../model/Model';
import {Breakpoint, getBreakpoint} from '../../utils/Breakpoint';
import {Events, EventType} from '../../events/Events';
import DesktopViewport from './DesktopViewport';
import MobileViewport from './MobileViewport';
import {ReadonlyContext} from '../context/ReadonlyContext';
import {TripContext} from '../context/TripContext';
import {UserContext} from '../context/UserContext';
import CopyToClipboardNotification from '../notification/CopyToClipboardNotification';
import {Appearance, AppearanceContext, getAppearance} from '../context/AppearanceContext';
import {Poi} from '../../react-app-env';
import {HoveringPoisContext} from '../context/HoveringPoisContext';
import {SelectedPoiContext} from '../context/SelectedPoiContext';

const FernrauschApp = () => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>();
  const [appearance, setAppearance] = React.useState<Appearance>();
  const [hoveringPois, setHoveringPois] = React.useState<Poi[]>();
  const [selectedPoi, setSelectedPoi] = React.useState<Poi>();

  const model = useModel((model) => {
    console.info('Model is available', model);
  });

  const ready = model != null &&
                appearance != null &&
                breakpoint != null &&
                hoveringPois != null;

  useEffect(() => {
    setBreakpoint(getBreakpoint());
    setAppearance(getAppearance());
    setHoveringPois([]);
  }, []);

  useEffect(() => {
    const subscriptions = Events
        .collect()
        .subscribe(EventType.BREAKPOINT_CHANGED, () => {
          setBreakpoint(getBreakpoint());
        })
        .subscribe(EventType.APPEARANCE_CHANGED, () => {
          setAppearance(getAppearance());
        })
        .subscribe(EventType.SELECT_POI, (poi: Poi) => {
          if (poi.id !== selectedPoi?.id) {
            setSelectedPoi(poi);
            Events.publish(EventType.ON_POI_SELECTED, poi);
          }
        })
        .subscribe(EventType.ON_POI_UNSELECTED, () => {
          setSelectedPoi(undefined);
        })
        .subscribe(EventType.ON_POIS_HOVERING, (pois: Poi[]) => {
          setHoveringPois(pois);
        });

    return () => subscriptions.cancel();
  }, [selectedPoi]);

  useEffect(() => {
    if (model && selectedPoi) {
      setSelectedPoi(model.trip.pois.find(poi => poi.id === selectedPoi.id));
    }
  }, [model, selectedPoi]);

  function renderViewport(): React.ReactNode {
    if (!ready) {
      return null;
    }

    if (breakpoint === Breakpoint.PHONE) {
      return <MobileViewport googleMapsApiKey={model.googleMapsApiKey}/>;
    } else {
      return <DesktopViewport googleMapsApiKey={model.googleMapsApiKey}/>;
    }
  }

  return <React.Fragment>
    <header>
    </header>
    <main>
      <div id="breakpoint-detector"></div>
      <div id="appearance-detector"></div>
      {ready || (
          <div>Loading...</div>
      )}
      {ready && (
          <React.Fragment>
            <AppearanceContext value={appearance}>
              <ReadonlyContext value={model.readonly}>
                <TripContext value={model.trip}>
                  <UserContext value={model.user}>
                    <HoveringPoisContext value={hoveringPois}>
                      <SelectedPoiContext value={selectedPoi}>
                        {renderViewport()}
                      </SelectedPoiContext>
                    </HoveringPoisContext>
                  </UserContext>
                </TripContext>
              </ReadonlyContext>
            </AppearanceContext>
            <PopupMenuView/>
            <CopyToClipboardNotification/>
          </React.Fragment>
      )}
    </main>
  </React.Fragment>;
};

export default FernrauschApp;
